export enum SwitchType {
  Emoji = "emoji",
  Gif = "gif",
}
